class Modal {
    constructor() {
        this.el = null;
        this.isOpen = false;
        this.validateFormBeforeClose = false;
        this.callbacks = {};
        this.history = [];
    }

    init() {
        if (this.el === null) {
            this.el = document.createElement('modal');
            this.el.innerHTML = '<div class="modal-mask can-close"><div class="modal-wrapper"><div class="modal-close can-close" aria-label="Close"></div><div class="modal-container"><div class="modal-header"></div><div class="modal-body"></div><div class="modal-footer"></div></div></div></div>';
            this.el.mask = this.el.querySelector('.modal-mask');
            this.el.wrapper = this.el.querySelector('.modal-wrapper');
            this.el.header = this.el.querySelector('.modal-header');
            this.el.body = this.el.querySelector('.modal-body');
            this.el.footer = this.el.querySelector('.modal-footer');
            this.el.close = this.el.querySelector('.modal-close');
            this.el.mask.addEventListener('mousedown', (e) => {
                if (e.target.classList.contains('can-close')) {
                    this.close();
                }
            });
        }
        document.body.appendChild(this.el);
        app.events.sub("page_change", () => {
            this.close();
        });
    }

    open(header, body, footer, cssClass, onOpenCallback, validateFormBeforeClosing, onCloseCallback) {
        if (this.isOpen) {
            this._close(() => {
                this._reset();
                this._show(header, body, footer, cssClass, onOpenCallback, onCloseCallback);
            });
        } else {
            this._show(header, body, footer, cssClass, onOpenCallback, onCloseCallback);
        }
        this.validateFormBeforeClose = validateFormBeforeClosing;
        this.history.push({
            header: header, body: body, footer: footer, cssClass: cssClass, onOpenCallback: onOpenCallback, validateFormBeforeClosing: validateFormBeforeClosing, onCloseCallback: onCloseCallback, scrollPosition: 0
        });
    }

    openClear(header, body, footer, cssClass, onOpenCallback, validateFormBeforeClosing, onCloseCallback) {
        this.clearHistory();
        this.open(header, body, footer, cssClass, onOpenCallback, validateFormBeforeClosing, onCloseCallback);
    }

    iframe(url) {
        let wrapper = document.createElement("div");
        let iframe = document.createElement("iframe");
        iframe.setAttribute("src", url);
        iframe.style.width = "100%";
        iframe.style.height = "480px";
        wrapper.appendChild(iframe);

        this.open("", wrapper.innerHTML, "");
    }

    close(callback, forceClose) {
        if (this.validateFormBeforeClose) {
            if (!this._validateForm() && !forceClose) {
                return false;
            }
        }
        this._close(() => {
            if (typeof callback === "function") {
                callback();
            }
            if (typeof this.callbacks.onCloseCallback === "function") {
                this.callbacks.onCloseCallback();
            } else if (typeof this.callbacks.onCloseCallback === "string") {
                eval(this.callbacks.onCloseCallback);
            }
            this._reset();
            this._remove();
            this.history.pop();
            let history = this.history.pop();
            if (history) {
                this.open(history.header, history.body, history.footer, history.cssClass, () => {
                    if (typeof history.onOpenCallback === "function") {
                        history.onOpenCallback();
                    }
                    if (history.scrollPosition.top) {
                        this.el.wrapper.scroll(history.scrollPosition.left, history.scrollPosition.top);
                    }
                    app.events.pub("modal_history_back");
                }, history.validateFormBeforeClosing, history.onCloseCallback);
            }
        });
    }

    clearHistory() {
        this.history = [];
    }

    _close(callback) {
        if (this.isOpen) {
            if (typeof this.history[this.history.length - 1] !== "undefined") {
                this.history[this.history.length - 1].body = $(".modal-body").first().html();
                this.history[this.history.length - 1].scrollPosition = {left: app.modal.el.wrapper.scrollLeft, top: app.modal.el.wrapper.scrollTop}
            }
            this.el.mask.classList.remove("showing");
            this.el.mask.classList.add("hiding");
        }
        if (typeof callback === 'function') {
            setTimeout(callback, 200);
        }
    }

    _show(header, body, footer, cssClass, onOpenCallback, onCloseCallback) {
        this.init()
        this.callbacks.onCloseCallback = onCloseCallback;
        document.body.classList.add('modal_open');
        this.isOpen = true;
        this.el.header.innerHTML = header;
        this.el.body.innerHTML = body;
        let autoFocus = this.el.body.querySelector('[autofocus]');
        if (autoFocus) {
            setTimeout(function () {
                autoFocus.focus();
            }, 300);
        }
        let autoClose = this.el.body.querySelector('auto-close');
        if (autoClose) {
            setTimeout(() => {
                this.close();
                this.close();
            }, autoClose.getAttribute('time') * 1000);
        }
        this.el.footer.innerHTML = footer;
        if (typeof cssClass == 'string') {
            let cssClasses = cssClass.split(' ');
            for (let cssClass of cssClasses) {
                this.el.classList.add(cssClass);
            }
        }
        let s = this.el.body.querySelectorAll("script");
        if (s.length) {
            for (let i in s) {
                if (typeof s[i] === "object") {
                    eval(s[i].innerHTML);
                }
            }
        }

        this.el.mask.classList.remove("hiding");
        this.el.mask.classList.add("showing");
        if (typeof onOpenCallback === "function") {
            onOpenCallback();
        }
        if (typeof onOpenCallback === "string") {
            onOpenCallback = Function(onOpenCallback);
            onOpenCallback();
        }

        app.events.pub('modal_open');
    }

    _reset() {
        this.isOpen = false;
        this.validateFormBeforeClose = false;
        if (this.el) {
            this.el.className = '';
        }
    }

    _remove() {
        document.body.classList.remove('modal_open');
        if (this.el) {
            this.el.innerHTML = "";
            app.util.removeElement(this.el);
            this.el = null;
        }
    }

    _validateForm() {
        let form = this.el.querySelector('form:first-of-type');
        return app.form.validate(form);
    }
}